import { render, staticRenderFns } from "./Lp.vue?vue&type=template&id=99bb65b8"
import script from "./Lp.vue?vue&type=script&lang=js"
export * from "./Lp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports